/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1AccesscontrolControllersQueryResponse,
  GetApiV1AccesscontrolControllers401,
  GetApiV1AccesscontrolControllers500,
} from "../../types/accessControlControllersController/GetApiV1AccesscontrolControllers.ts";

function getGetApiV1AccesscontrolControllersUrl() {
  const res = {
    method: "GET",
    url: `/api/v1/accesscontrol/controllers` as const,
  };
  return res;
}

/**
 * @description Retorna todos os controllers cadastrados. **(Requer Authorization para autenticação)**
 * @summary Buscar todos os controllers (Requer Authorization para autenticação)
 * {@link /api/v1/accesscontrol/controllers}
 */
export async function getApiV1AccesscontrolControllers(
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1AccesscontrolControllersQueryResponse,
    ResponseErrorConfig<
      GetApiV1AccesscontrolControllers401 | GetApiV1AccesscontrolControllers500
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiV1AccesscontrolControllersUrl().url.toString(),
    ...requestConfig,
  });
  return res.data;
}
